module.exports = __webpack_public_path__ + "01_face.5aeb20c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer1/01_face.png
// module id = DPFq
// module chunks = 0